export type ISwitchLanguage = (elm: IjQueryElmOrHtmlElm, type: 'button' | 'select') => void;

export function switchLanguage(elm: IjQueryElmOrHtmlElm, type: 'button' | 'select') {
  const currentUrl = window.location.href;
  const $elm = $(elm) as IjQueryElm;
  // activeLocale == previous locale / requestedLocale == new locale
  let newUrl;
  let requestedLocale;
  let activeLocale;
  if (type === 'button') {
    const $buttonGroup = $elm.closest('.btn-group');

    const $activeBtn = $buttonGroup.find('.active');
    requestedLocale = $elm.data('locale');
    activeLocale = $activeBtn.data('locale');
    if (
      $elm.get(0) === $activeBtn.get(0) ||
      typeof requestedLocale === 'undefined' ||
      typeof activeLocale === 'undefined'
    ) {
      return;
    }
  } else if (type === 'select') {
    const $options = $elm.find('option');
    const $previousOption = $options.filter((_, opt) => $(opt).hasClass('current-value'));
    const $currentOption = $options.filter((_, opt) => $(opt).prop('selected'));

    activeLocale = $previousOption.val();
    requestedLocale = $currentOption.val();
  }
  // Replace and redirect
  const re = new RegExp(`/${activeLocale}/`, 'g');
  const reEnd = new RegExp(`${activeLocale}$`, 'g');
  if (re.test(currentUrl)) {
    newUrl = currentUrl.replace(`/${activeLocale}/`, `/${requestedLocale}/`);
  } else if (reEnd.test(currentUrl)) {
    newUrl = currentUrl.replace(reEnd, `${requestedLocale}`);
  }
  if (newUrl !== undefined && newUrl !== '') {
    window.DexeroCoreApp.blockUI($('body'));
    window.location.href = newUrl;
  }
}
